var map = {
	"./doc-at-home.jpg": 8205,
	"./investiga-at-home.jpg": 2675,
	"./medic-equipt.jpg": 6014,
	"./medicine-at-home.jpg": 1631,
	"./medicine-at-home.png": 2383,
	"./nurse-at-home.jpg": 9752,
	"./physio-at-home.jpg": 7635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6513;